// Generated by CoffeeScript 2.7.0
var Geolocation, _consumeCallbacks, getOrCreateElementById;

import Utilities from 'helpers/utilities.js';

({getOrCreateElementById} = Utilities);

_consumeCallbacks = function(callbacks, {error, data}) {
  var cb, results;
  results = [];
  while (cb = callbacks.shift()) {
    results.push(cb(error, data));
  }
  return results;
};

export default Geolocation = (function() {
  class Geolocation {
    // position {Object} gcj02 火星坐标
    //   - longitude
    //   - latitude
    //   - accuracy
    //   - type (default is gcj02)
    // initRegeocode {Boolean} (default is false)
    constructor({
        position: position1,
        initRegeocode
      }) {
      this.position = position1;
      this._getRegeocodeCallbacks = [];
      if (initRegeocode == null) {
        initRegeocode = false;
      }
      this._formatPosition();
      if (initRegeocode) {
        this.getRegeocode();
      }
    }

    // https://github.com/wandergis/coordtransform/blob/master/index.js
    static Wgs84ToGcj02(position) {
      var a, dlat, dlng, ee, lat, lng, magic, rlat, sqrtMagic, transformLat, transformLng;
      lat = position.latitude;
      lng = position.longitude;
      a = 6378245;
      ee = 0.00669342162296594323;
      transformLat = function(x, y) {
        var ret;
        ret = -100.0 + 2.0 * x + 3.0 * y + 0.2 * y * y + 0.1 * x * y + 0.2 * Math.sqrt(Math.abs(x));
        ret += (20.0 * Math.sin(6.0 * x * Math.PI) + 20.0 * Math.sin(2.0 * x * Math.PI)) * 2.0 / 3.0;
        ret += (20.0 * Math.sin(y * Math.PI) + 40.0 * Math.sin(y / 3.0 * Math.PI)) * 2.0 / 3.0;
        return ret += (160.0 * Math.sin(y / 12.0 * Math.PI) + 320 * Math.sin(y * Math.PI / 30.0)) * 2.0 / 3.0;
      };
      transformLng = function(x, y) {
        var ret;
        ret = 300.0 + x + 2.0 * y + 0.1 * x * x + 0.1 * x * y + 0.1 * Math.sqrt(Math.abs(x));
        ret += (20.0 * Math.sin(6.0 * x * Math.PI) + 20.0 * Math.sin(2.0 * x * Math.PI)) * 2.0 / 3.0;
        ret += (20.0 * Math.sin(x * Math.PI) + 40.0 * Math.sin(x / 3.0 * Math.PI)) * 2.0 / 3.0;
        return ret += (150.0 * Math.sin(x / 12.0 * Math.PI) + 300.0 * Math.sin(x / 30.0 * Math.PI)) * 2.0 / 3;
      };
      dlat = transformLat(lng - 105.0, lat - 35.0);
      dlng = transformLng(lng - 105.0, lat - 35.0);
      rlat = lat / 180 * Math.PI;
      magic = Math.sin(rlat);
      sqrtMagic = Math.sqrt(1 - ee * magic * magic);
      dlat = (dlat * 180.0) / ((a * (1 - ee)) / (magic * sqrtMagic) * Math.PI);
      dlng = (dlng * 180.0) / (a / sqrtMagic * Math.cos(rlat) * Math.PI);
      return {
        latitude: lat + dlat,
        longitude: lng + dlng,
        accuracy: position.accuracy,
        type: 'gcj02'
      };
    }

    static GetCurrentLocation(callback) {
      var geolocation;
      if (callback != null) {
        this._getCurrentLocationCallbacks.push(callback);
      }
      if (!this._locating) {
        this._locating = true;
        if ((typeof wx !== "undefined" && wx !== null) && wx.getLocation) {
          return wx.getLocation({
            type: 'gcj02',
            success: (res) => {
              return _consumeCallbacks(this._getCurrentLocationCallbacks, {
                error: false,
                data: new Geolocation({
                  position: {
                    longitude: res.longitude,
                    latitude: res.latitude,
                    accuracy: res.accuracy
                  }
                })
              });
            },
            fail: (error) => {
              return _consumeCallbacks(this._getCurrentLocationCallbacks, {
                error: {
                  code: 1,
                  message: 'permission_denied'
                }
              });
            },
            complete: () => {
              return this._locating = false;
            }
          });
        } else if ((typeof AMap !== "undefined" && AMap !== null) && (AMap.Geolocation != null)) {
          geolocation = new AMap.Geolocation({
            timeout: 10 * 1000,
            GeoLocationFirst: true,
            showButton: false,
            showMarker: false,
            showCircle: false,
            panToLocation: false
          });
          return geolocation.getCurrentPosition((status, result) => {
            this._locating = false;
            if (status === 'complete') {
              this.regeocode = {
                formattedAddress: result.formattedAddress
              };
              return _consumeCallbacks(this._getCurrentLocationCallbacks, {
                error: false,
                data: new Geolocation({
                  position: {
                    longitude: result.position.getLng(),
                    latitude: result.position.getLat(),
                    accuracy: result.accuracy
                  }
                })
              });
            } else {
              return _consumeCallbacks(this._getCurrentLocationCallbacks, {
                error: result
              });
            }
          });
        } else {
          this._locating = false;
          return _consumeCallbacks(this._getCurrentLocationCallbacks, {
            error: {
              message: '当前不支持定位!'
            }
          });
        }
      }
    }

    getRegeocode(callback) {
      if (callback != null) {
        this._getRegeocodeCallbacks.push(callback);
      }
      if (this.regeocode != null) {
        return _consumeCallbacks(this._getRegeocodeCallbacks, {
          data: this.regeocode
        });
      } else {
        return this._decodePosition((error, regeocode) => {
          if (error) {
            return _consumeCallbacks(this._getRegeocodeCallbacks, {
              error: error
            });
          } else {
            this.regeocode = regeocode;
            return _consumeCallbacks(this._getRegeocodeCallbacks, {
              data: this.regeocode
            });
          }
        });
      }
    }

    calculateDistance(_location) {
      var _getRadian, lat1, lat2, lng1, lng2, r;
      r = 6371 * 1000;
      _getRadian = function(degree) {
        return degree / 180 * Math.PI;
      };
      lng1 = _getRadian(this.position.longitude);
      lat1 = _getRadian(this.position.longitude);
      lng2 = _getRadian(_location.position.longitude);
      lat2 = _getRadian(_location.position.longitude);
      return r * Math.acos(Math.cos(lat1) * Math.cos(lat2) * Math.cos(lng2 - lng1) + Math.sin(lat1) * Math.sin(lat2));
    }

    nearBy(_location, distance) {
      return this.calculateDistance(_location) <= distance;
    }

    // private
    _formatPosition() {
      if (this.position.type === 'wgs84') {
        this.position = this.constructor.Wgs84ToGcj02(this.position);
      }
      this.position.longitude = parseFloat(this.position.longitude);
      return this.position.latitude = parseFloat(this.position.latitude);
    }

    _getAddress(cb = _.noop) {
      var geocoder;
      geocoder = new AMap.Geocoder({
        radius: 1000,
        extensions: 'all'
      });
      return geocoder.getAddress([this.position.longitude.toFixed(6), this.position.latitude.toFixed(6)], function(status, result) {
        if (status === 'complete' && result.info === 'OK') {
          return cb(false, result.regeocode);
        } else {
          return cb(true, result);
        }
      });
    }

    _decodePosition(cb = _.noop) {
      var map;
      getOrCreateElementById('map_container');
      if ((typeof AMap !== "undefined" && AMap !== null ? AMap.Geocoder : void 0) != null) {
        return this._getAddress(cb);
      } else {
        map = new AMap.Map('map_container');
        return map.plugin(['AMap.Geocoder'], () => {
          return this._getAddress(cb);
        });
      }
    }

  };

  Geolocation._getCurrentLocationCallbacks = [];

  Geolocation._locating = false;

  return Geolocation;

}).call(this);
